import { render, staticRenderFns } from "./LinkExsistingClientModel.vue?vue&type=template&id=12ff9e05&scoped=true"
import script from "./LinkExsistingClientModel.vue?vue&type=script&lang=js"
export * from "./LinkExsistingClientModel.vue?vue&type=script&lang=js"
import style0 from "./LinkExsistingClientModel.vue?vue&type=style&index=0&id=12ff9e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff9e05",
  null
  
)

export default component.exports